<template>
  <div class="chain-supplier-tree">
    <el-card class="box-card">
      <el-tree
        ref="supplierTree"
        :data="suppliersTreeData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
      >
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <i :class="data.icon" style="margin-right: 5px"></i>
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </el-card>
  </div>
</template>

<script>
import { listChainSupplier } from '@/api/goods/chainSupplierApi'

export default {
  name: 'ChainSupplierTree',
  data() {
    return {
      suppliersTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      csId: ''
    }
  },
  created() {
    this.loadChainSuppliers()
  },
  methods: {
    loadChainSuppliers() {
      listChainSupplier({
        page: 1,
        row: 50
      }).then(response => {
        this.suppliersTreeData = this.formatTreeData(response.data)
      })
    },
    formatTreeData(suppliers) {
      const treeData = []
      const processedSuppliers = new Set()

      suppliers.forEach(item => {
        if (!processedSuppliers.has(item.csId)) {
          processedSuppliers.add(item.csId)
          
          const supplierItem = {
            id: `cs_${item.csId}`,
            csId: item.csId,
            text: item.name,
            icon: 'el-icon-office-building',
            children: []
          }

          if (item.catalogs && item.catalogs.length > 0) {
            item.catalogs.forEach(catalog => {
              supplierItem.children.push({
                id: `c_${catalog.catalogId}`,
                catalogId: catalog.catalogId,
                csId: item.csId,
                text: catalog.catalogName,
                icon: 'el-icon-folder-opened'
              })
            })
          }

          treeData.push(supplierItem)
        }
      })

      return treeData
    },
    handleNodeClick(data) {
      if (data.id.startsWith('cs_')) {
        this.$emit('switchSupplier', { csId: data.csId })
      } else {
        this.$emit('switchCatalog', { csId: data.csId, catalogId: data.catalogId })
      }
    },
    refreshTree(params) {
      if (params) {
        this.csId = params.csId
      }
      this.loadChainSuppliers()
    }
  }
}
</script>

<style lang="scss" scoped>
.chain-supplier-tree {
  .box-card {
    height: 100%;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>